import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-spinner',
  templateUrl: './popup-spinner.component.html',
  styleUrls: ['./popup-spinner.component.scss']
})
export class PopupSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
